'use strict';

namespace Core {

    class ScSticky {

        private element: JQuery;
        private placeholder: JQuery|undefined;
        private stickyClass: string;
        private isStuck: boolean = false;
        private stickingPoint: number|undefined;
        private eventNamespace: string = `.${this.componentUtil.getRandomID('sticky-el')}`;

        constructor (
            private $window: ng.IWindowService,
            private $scope: ng.IScope,
            private componentUtil: TR.ComponentUtil,
            private scrollService: any
        ) {
        }

        public init (element: ng.IAugmentedJQuery, attributes: ng.IAttributes): void {
            this.element = element;

            // Classes
            this.stickyClass = attributes.stickyClass || '';

            $(this.$window).on(`scroll${this.eventNamespace}`, () => this.checkPosition());

            this.$scope.$on('$destroy', () => this.destroy());
        }

        private checkPosition (): void {
            if (!this.isStuck) {
                // Get the element's position from the top of the viewport
                const offsetFromTop: number = this.element.offset().top;
                this.stickingPoint = offsetFromTop;
            }

            if (this.stickingPoint) {
                const scrollbarPosition: number = this.scrollService.getScrollOffsets(this.$window).y;
                scrollbarPosition > this.stickingPoint
                    ? this.stick()
                    : this.unstick();
            }
        }

        private stick (): void {
            if (this.isStuck) {
                return;
            }
            this.isStuck = true;
            this.$scope.onStick && this.$scope.onStick();

            this.showPlaceholder();
            this.element.addClass(this.stickyClass);
        }

        private unstick (): void {
            if (!this.isStuck) {
                return;
            }
            this.isStuck = false;
            this.$scope.onUnstick && this.$scope.onUnstick();

            this.placeholder && this.placeholder.remove();
            this.element.removeClass(this.stickyClass);
        }

        private showPlaceholder (): void {
            if (!this.placeholder) {
                // create a placeholder which matches the height of the nav bar
                this.placeholder = $('<div>');
                const style: any = this.$window.getComputedStyle(this.element[0]);
                let height = this.element[0].offsetHeight;
                height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
                this.placeholder.css('height', `${height}px`);
            }
            this.element.after(this.placeholder);
        }

        private destroy (): void {
            $(this.$window).off(this.eventNamespace);
            this.placeholder && this.placeholder.remove();
        }

    }

    angular
        .module('core')
        .directive('scStickyEl', (): ng.IDirective => {
            return {
                restrict: 'A',
                controller: ScSticky,
                controllerAs: 'ctrl',
                scope: {
                    onStick: '&',
                    onUnstick: '&'
                },
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller : ScSticky
                ) => {
                    controller.init(el, attr);
                }
            };
        });
}

